import { Collaborator, User } from '../types';

export const filterByPermission = (users: User[], permission: string) => {
  return users.filter((u) => u.permissions.includes(permission));
};

export const excludeCollaborators = (users: User[], collaborators: Collaborator[]) => {
  const collaboratorIds = new Set(collaborators.map(({ id }) => id));
  return users.filter((u) => !collaboratorIds.has(u.id));
};

export const filterActiveUsers = (users: User[]) => {
  return users.filter((u) => u.active !== false);
};

export const filterByPermissionButInclude = (users: User[], permission: string, includeUserId: string | null) => {
  return users.filter((u) => u.permissions.includes(permission) || (includeUserId && Number(includeUserId) === u.id));
};

export const getUserTZ = (userId: number, usersData: User[]): string => {
  const tz = usersData?.find((user) => user.id === userId)?.tz;
  return tz || 'UTC';
};
